<template>
  <modal :show="visible" @close="visible = false" :gradient="'info'">
    <div slot="header">
      Cập nhật quyền
    </div>
    <template>
      <block transparent="true" :nobody="true" ref="bmdal">
        <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
          <form role="form" @submit.prevent="handleSubmit">
            <b-row>
              <b-col cols="12">
                <div class="text-light mb-4" v-if="user.role">
                  Quyền hiện tại : <strong>{{ user.role.name }}</strong>
                </div>
              </b-col>
              <b-col cols="12" class="mb-4">
                <label class="form-control-label text-light">
                  Chọn quyền mới
                </label>
                <ValidationProvider name="mật khẩu" rules="required">
                  <!-- :options="roles" -->
                  <Select2
                    :required="true"
                    v-model="roleId"
                    :settings="{
                      ajax: {
                        transport: function(params, success, failure) {
                          getListRole(params, success, failure);
                        }
                      },
                      placeholder: 'Chọn quyền',
                      templateResult: formatSelect2,
                      templateSelection: formatSelectionSelecte2
                    }"
                  />
                  <div
                    v-if="roleId == ''"
                    class="text-danger invalid-feedback mt-2"
                    style="display: block; padding: 0px 5px 10px 10px; font-style: italic; opacity: 0.7;"
                  >
                    Vui lòng chọn quyền cho nhân viên
                  </div>
                </ValidationProvider>
              </b-col>
            </b-row>
          </form>
          <b-row>
            <b-col sm="6" xs="12" md="6">
              <b-button
                class="mb-2"
                type="submit"
                block
                variant="dark"
                @click="doSave(0)"
              >
                Lưu đóng (F4)
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button
                class="mb-2"
                block
                variant="secondary"
                @click="handleClose"
              >
                Đóng (Esc)
              </b-button>
            </b-col>
          </b-row>
        </ValidationObserver>
      </block>
    </template>
  </modal>
</template>
<script>
import { roleService, userService } from "@/_services";
import $ from "jquery";
export default {
  name: "add-button",
  props: {},
  data() {
    return {
      visible: false,
      roleId: 0,
      user: {},
      ownInfo: {}
    };
  },
  methods: {
    setData(user) {
      this.ownInfo = user;
      this.user = Object.assign({}, user);
      if (user.role) this.roleId = user.role.id;
      else this.roleId = 0;
    },
    doSave(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        userService
          .updateRole(self.user.id, self.roleId)
          .then(res => {
            self.ownInfo.role = res.data.role;
            if (type == 0) {
              self.visible = false;
            }
            this.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csInfo.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bmdal.unBlock();
          });
      });
    },
    handleClose() {
      this.visible = false;
    },
    formatSelect2(item) {
      if (item.loading) {
        return "Vui lòng đợi chúng tôi lấy lại dữ liệu ...";
      }
      var $container = $(`<div class='clearfix' style="padding:4px 3px;">
                        <div class='select2-result-repository__avatar' style="float: left;width: 30px;margin-right: 10px;">
                           <img style="width: 100%;height: auto;" src='https://cdn.onlinewebfonts.com/svg/img_315540.png' />
                        </div>
                        <div style="margin-left: 40px;" class='select2-result-repository__meta'>
                          <strong>${item.name}</strong> <br>
                          <span>${item.description}</span>
                        </div>
                    </div>
      `);
      return $container;
    },
    formatSelectionSelecte2(item) {
      return item.name || item.text;
    },
    getListRole(params, success) {
      roleService
        .getlist({})
        .then(res => {
          var results = res.data;
          if (params.data.q) {
            results = res.data.filter(item => {
              return (
                item.name.toLowerCase().includes(params.data.q.toLowerCase()) ||
                item.description
                  .toLowerCase()
                  .includes(params.data.q.toLowerCase())
              );
            });
          }
          success({
            results: results,
            pagination: {
              more: params.page * 30 < res.data.length
            }
          });
        })
        .catch(err => {
          this.pending = false;
          this.$alertify.error(err.message, {
            duration: 4000
          });
        });
    }
  }
};
</script>
